module.exports = __webpack_public_path__ + "static/media/Pouť-95-MCoppa-3.46ed83c5.jpg";